<template>
  <td class="soprts_in_acc_2 "
      style="width: 25%;"
      :class="{'sel': checkCart(bets)}"
      @click="addCart(bets, folder, game)"
  >
    <div class="sports_v_l_1">
      {{ name }}
    </div>
    <div class="sports_v_r_1">
      <i v-if="up" class="ico-up blink"></i>
      <i v-if="down" class="ico-down blink"></i>
      <span class="font_002 ">
        {{ Number(bets.price).toFixed(2) }}
      </span>
      <i v-if="up || down" class="sel_old ">({{ startPrice }})</i>
    </div>
  </td>
</template>

<script>
export default {
  name: "Price",
  props: ['bets', 'folder', 'addCart', 'checkCart', 'game'],
  data: function(){
    return {
      startPrice: null,
      up: false,
      down: false
    }
  },
  computed: {
    name: function(){
      // let name = this.bets.name;
      let name = this.bets.displayName;
      if (name?.indexOf('W1 and Over') >= 0){
        name = name.replace('W1 and Over', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 오버`)
      }
      if (name?.indexOf('W2 and Over') >= 0){
        name = name.replace('W2 and Over', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 오버`)
      }
      if (name?.indexOf('12 and Over') >= 0){
        name = name.replace('12 and Over', '12 & 오버')
      }
      if (name?.indexOf('W1 and Under') >= 0){
        name = name.replace('W1 and Under', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 언더`)
      }
      if (name?.indexOf('W2 and Under') >= 0){
        name = name.replace('W2 and Under', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 언더`)
      }
      if (name?.indexOf('12 and Under') >= 0){
        name = name.replace('12 and Under', '12 & 언더')
      }

      if (name?.indexOf('1X and Over') >= 0){
        name = name.replace('1X and Over', '1X & 오버')
        return name;
      }
      if (name?.indexOf('Draw and Over') >= 0){
        name = name.replace('Draw and Over', '무 & 오버')
      }
      if (name?.indexOf('X and Over') >= 0){
        name = name.replace('X and Over', '무 & 오버')
      }
      if (name?.indexOf('X2 and Over') >= 0){
        name = name.replace('X2 and Over', 'X2 & 오버')
      }
      if (name?.indexOf('1X and Under') >= 0){
        name = name.replace('1X and Under', '1X & 언더')
      }
      if (name?.indexOf('Draw And Under') >= 0){
        name = name.replace('Draw And Under', '무 & 언더')
      }
      if (name?.indexOf('X And Under') >= 0){
        name = name.replace('X And Under', '무 & 언더')
      }
      if (name?.indexOf('X2 and Under') >= 0){
        name = name.replace('X2 and Under', 'X2 & 언더')
      }
      if (name?.indexOf('ormore') >= 0){
        name = name.replace('ormore', '골 또는 그이상')
      }
      if (name === 'AnyOther'){
        name = name.replace('AnyOther', '기타')
      }
      if (name === ''){
        name = this.bets.displayName
      }
      if (name?.indexOf('W1andOver') >= 0){
        name = name.replace('W1andOver', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 오버`)
      }
      if (name?.indexOf('W2andOver') >= 0){
        name = name.replace('W2andOver', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 오버`)
      }
      if (name?.indexOf('12andOver') >= 0){
        name = name.replace('12andOver', '12 & 오버')
      }
      if (name?.indexOf('W1andUnder') >= 0){
        name = name.replace('W1andUnder', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 언더`)
      }
      if (name?.indexOf('W2andUnder') >= 0){
        name = name.replace('W2andUnder', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 언더`)
      }
      if (name?.indexOf('12andUnder') >= 0){
        name = name.replace('12andUnder', '12 & 언더')
      }

      if (name?.indexOf('1XandOver') >= 0){
        name = name.replace('1XandOver', '1X & 오버')
        return name;
      }
      if (name?.indexOf('XandOver') >= 0){
        name = name.replace('XandOver', '무 & 오버')
      }
      if (name?.indexOf('X2andOver') >= 0){
        name = name.replace('X2andOver', 'X2 & 오버')
      }
      if (name?.indexOf('1XandUnder') >= 0){
        name = name.replace('1XandUnder', '1X & 언더')
      }
      if (name?.indexOf('XAndUnder') >= 0){
        name = name.replace('XAndUnder', '무 & 언더')
      }
      if (name?.indexOf('X2andUnder') >= 0){
        name = name.replace('X2andUnder', 'X2 & 언더')
      }
      if (name?.indexOf('ormore') >= 0){
        name = name.replace('ormore', '골 또는 그이상')
      }
      if (name === 'AnyOther'){
        name = name.replace('AnyOther', '기타')
      }
      if (name === ''){
        name = this.bets.displayName
      }
      return name;
    }
  },
  watch: {
    price: function(newVal, val){
      if (Number(newVal) - Number(val) < 0) this.down = true;
      if (Number(newVal) - Number(val) > 0) this.up = true;
      if (Number(newVal) !== Number(val)) this.startPrice = val;
    },
    up: function(){
      setTimeout(() => {
        this.up = false
        this.startPrice = null;
      } ,10000)
    },
    down: function(){
      setTimeout(() => {
        this.down = false
        this.startPrice = null;
      } ,10000)
    }
  },
}
</script>

<style scoped>
.blink {
  animation: top-arrow-down 1s 10!important;
}
</style>
